import { useEffect, useState } from 'react';
import { IMainStep, IMainStepData } from '../../../../../models/freshman/mainStep'
import { connect, useDispatch } from 'react-redux';
import { setMainSteps } from '../../../../../store/slices/freshman/mainStepSlice';
import { getAllMainSteps, getMainStep, inactiveMainStep } from '../../../../../action/freshman/mainstepActionCreator';
import LoaderSpinner from '../../../../../common-components/loader';
import MainStepCreate from './mainStepCreate';
import ReactModal from 'react-modal';
import MainStepEdit from './mainStepEdit';
import SweetAlert from 'react-bootstrap-sweetalert';
import { alertConstants, getAlertData } from '../../../../../helper/sweet-alert';

const MainStepIndex = (props: IMainStep) => {
  const { getAllMainSteps, mainSteps, getMainStep, mainStep, inactiveMainStep } = props;
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");


  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const getMainSteps = async () => {
    setIsLoading(true);
    try {
      await getAllMainSteps(true);
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getMainSteps();
    return () => {
      dispatch(setMainSteps([]))
    }
  }, [])

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true)
    try {
      await getMainStep(id);
    } finally {
      setIsEditLoading(false)
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      inactiveMainStep(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getMainSteps();
    }
  };


  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Main Task</h2>
          <a
            className="btn btn-primary"
            onClick={handleCreateOpen}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : (
            mainSteps && mainSteps.length > 0 ? (
              mainSteps?.map((mainStep: IMainStepData) => (
                <li className="admin-card" key={mainStep.id} style={{ pointerEvents: !mainStep.isActive ? "none" : "auto", opacity: !mainStep.isActive ? 0.5 : 1}}>
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(mainStep.id ?? 0)}>
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(mainStep.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>

                  <div className="btm">
                    <h2 className="para-hide-1">{mainStep.name}</h2>
                    <p className="para-hide-1">{mainStep.description}</p>
                  </div>
                </li>
              ))
            ) : (
              <p>No Records Found</p>
            )
          )}
        </ul>
      </div >
      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <MainStepCreate
          setShowCreate={handleCreateClose}
          getAllMainSteps={(includeInactive:boolean) => getAllMainSteps(includeInactive)}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <MainStepEdit
            setShowEdit={handleEditClose}
            getAllMainSteps={(includeInactive:boolean) => getAllMainSteps(includeInactive)}
            mainStep={mainStep}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  )
}

const mapDispatchToProps = {
  getAllMainSteps: (includeInactive: boolean) => getAllMainSteps(includeInactive),
  getMainStep: (id: number) => getMainStep(id),
  inactiveMainStep: (id: number, callBack: Function) => inactiveMainStep(id, callBack)
};

function mapStateToProps(state: any) {
  return {
    mainSteps: state.mainStep.mainSteps,
    mainStep: state.mainStep.mainStep,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainStepIndex);